import * as React from 'react';
import { Box, Button, Container, Grid, Stepper, Step, StepLabel, List, ListItem, ListItemText, Divider, Typography } from '@mui/material';
import { Table } from 'antd';
import { formatPrice } from '../../../shared/utils';
import { SvgCard } from '../../../shared/SvgCard/SvgCard';
import { useAppDispatch, useAppSelector } from 'src/app/react/hooks/redux';
import { useEffect } from 'react';
import { getPurchaseSummary } from 'src/app/react/redux/purchase/actions';
import { Auth } from 'src/app/models/auth';

interface ConfirmationPurchaseProps {
    onPurchaseConfimation: () => void;
}

const { Column } = Table;

export const ConfirmationPurchase = ({onPurchaseConfimation}: ConfirmationPurchaseProps) => {

    const currentUser: Auth = JSON.parse(localStorage.getItem('currentUser'));

    const dispatch = useAppDispatch();

    const { purchase, summary, summaryLoading } = useAppSelector(state => state.purchase);


    useEffect(() => {
        dispatch(getPurchaseSummary(currentUser.token.assignorGuid, currentUser.token.userReferenceId, purchase, 0, 0, 0, summary))
    },[])

    return (
        <>
        <Grid container spacing={1}>
            <Grid item xs={8} className="p-4" key={"confimationGridTable"}>
                <Typography variant="h5">Confirmação da Recarga</Typography>
                <Table
                    loading={summaryLoading}
                    dataSource={summary?.summaryItens}
                    title={() => (<h5 style={{textAlign: 'end'}}>{summary?.summaryItens?.length} Produto{summary?.summaryItens?.length > 1 ? 's' : ''}</h5>)}
                    pagination={false}
                    rowKey="productId"
                >
                <Column
                    title="Produto"
                    dataIndex="productName"
                    key="productId"
                    width={20}
                />
                <Column
                    title="Colaboradores"
                    dataIndex="total"
                    key="total"
                    width={10}
                />
                <Column
                    title="Taxa"
                    dataIndex="fee"
                    key="fee"
                    width={10}
                    render={(text) => (formatPrice(text))}
                />
                <Column
                    title="Total"
                    dataIndex="value"
                    key="value"
                    width={10}
                    render={(text) => (formatPrice(text))}
                />
                </Table>
            </Grid>
            <Grid item xs={4} className="p-0" key={"confimationGridResume"}>
                <Box sx={{width: '100%', height: '100%', backgroundColor: '#f6f6f6', padding: '1.5rem'}}>
                    <Typography variant="h5">Resumo</Typography>

                    <Typography variant="h6" mt={2} sx={{fontSize: '1rem'}}>
                        Subtotal: {formatPrice(summary?.subTotal)}
                        <br></br>
                        Valor taxa: {formatPrice(summary?.totalFee)}
                    </Typography>

                    <Divider />

                    <Typography variant="h5">Total a Pagar: {formatPrice(summary?.total)}</Typography>
                    <Box sx={{textAlign: 'center'}} className="my-5">
                        <Button
                            variant="contained"
                            size="large"
                            sx={{width: '70%'}}
                            onClick={onPurchaseConfimation}
                        >
                            Pagar
                        </Button>
                    </Box>
                </Box>
            </Grid>
        </Grid>
        </>
    );
}
